<template>
    <MenuButton
        :title="$t('nav-menu-faq')"
        placement="bottom"
        :variant="routeName.startsWith('help___') ? 'accent' : 'outline'"
        :on-click="handleClick"
    >
        <HelpIcon class="w-6 h-6" />
    </MenuButton>
</template>

<script setup>
import { ROUTES } from "@utils/routes";
import MenuButton from "@components/ui/menu-button";
import HelpIcon from "@components/icons/outline/help-icon";

const route = useRoute();

const routeName = computed(() => route?.name || '');

const handleClick = async () => {
    await navigatorTo(translatePath(ROUTES.CODE.HELP));
};

</script>
